import Layout from '@/components/layout/Layout.vue'
import { deleteAdvertisers, getAdvertisers, updateAdvertiser, pullWechatApp, pullAnchor, syncLandingPage, pullEventAsset, getExportCsv, getAdvertiserCampaigns, pullAdvertiserCampaigns, deleteAdvertiserCampaigns, deleteAllAdvertiserCampaigns } from '@/api/advertiser'
import { getMedias, getPlatformAppTypes } from '@/api/constant'
import { pullAvatar } from '@/api/advertiser'
import { getWorkers, getTeams, syncAdvertiserName, getTeamSettings } from '@/api/open'
import PullForm from '@/views/sys/advertiser/pull/Pull.vue'
import CostForm from '@/views/sys/advertiser/cost/Cost.vue'
import BindForm from '@/views/sys/advertiser/bind/Bind.vue'
import UnbindForm from '@/views/sys/advertiser/unbind/Bind.vue'
import SyncCostForm from '@/views/sys/advertiser/sync-cost/SyncCost.vue'
import CreateAppForm from '@/views/sys/advertiser/create-app/CreateApp.vue'
import ShowWechatappsForm from '@/views/sys/advertiser/wechat-apps/Wechatapps.vue'
import ShowAnchorsForm from '@/views/sys/advertiser/anchor/Anchor.vue'
import CreateAnchorForm from '@/views/sys/advertiser/anchor/create/Create.vue'
import CreateAvatarForm from '@/views/sys/advertiser/create-avatar/CreateAvatar.vue'
import CreatePtForm from '@/views/sys/advertiser/create-pt/CreatePt.vue'
import CreatePtZyForm from '@/views/sys/advertiser/create-pt-zy/CreatePtZy.vue'
import showProjectsPage from '@/views/sys/advertiser/project/Project.vue'
import CreateProjectForm from '@/views/sys/advertiser/project/create/Create.vue'
import { getMediaAccounts, getCorporations, getJuliangEmails, getKuaishouEmails } from '@/api/open'
import CreateHandselForm from '@/views/sys/advertiser/create-handsel/CreateHandsel.vue'
import CreateEventAssetForm from '@/views/sys/advertiser/create-event-assets/CreateEventAsset.vue'
import CreateAndroidEventAssetForm from '@/views/sys/advertiser/create-android-event-asset/CreateAndroidEventAsset.vue'
import { getMaterials } from '@/api/local-material'
import ShowPromotionReportsPage from '@/views/sys/promotion/report/Report.vue'
import moment from 'moment'
import CreateProductForm from '@/views/sys/advertiser/create-product/CreateProduct.vue'
import AdvertiserTaskForm from '@/components/advertiser-task/AdvertiserTask.vue'
import JumpJuliangPage from '@/views/sys/advertiser/jump-juliang/JumpJuliang.vue'
import CreateEmailForm from '@/views/sys/advertiser/create-email/CreateEmail.vue'
import CreateBudgetForm from '@/views/sys/advertiser/create-budget/CreateBudget.vue'
import RemarkForm from '@/views/sys/advertiser/remark/Remark.vue'
import LabelForm from '@/views/sys/advertiser/label/Label.vue'
import CheckCloseProjectForm from '@/views/sys/advertiser/check-close-project/CheckCloseProject.vue'
import UploadForm from '@/views/sys/advertiser/upload/Upload.vue'
import { addAppEventAssetEvents } from '@/api/app-event-asset-task'

export default {
    props: ["typea"],
    components: {
        Layout,
        PullForm,
        CostForm,
        BindForm,
        UnbindForm,
        SyncCostForm,
        CreateAppForm,
        ShowWechatappsForm,
        ShowAnchorsForm,
        CreateAnchorForm,
        CreateAvatarForm,
        CreatePtForm,
        CreatePtZyForm,
        showProjectsPage,
        CreateProjectForm,
        CreateHandselForm,
        CreateEventAssetForm,
        CreateAndroidEventAssetForm,
        ShowPromotionReportsPage,
        CreateProductForm,
        AdvertiserTaskForm,
        JumpJuliangPage,
        CreateEmailForm,
        CreateBudgetForm,
        RemarkForm,
        LabelForm,
        UploadForm,
        CheckCloseProjectForm,
    },
    data() {
        return {
            data: [],
            loading: false,
            medias: [],
            workers: [],
            teams: [],
            selectedRowKeys: [],
            columns: [
                { width: 60,  type: 'checkbox' ,fixed: 'left'},
                { minWidth: 230, title: '广告主ID', field: 'out_id', ellipsis: true ,fixed: 'left', slots: { default: 'out_id' }},
                { minWidth: 260, title: '邮箱', ellipsis: true, slots: { default: 'email' } },
                { minWidth: 200, title: '账号昵称', field: 'name', ellipsis: true, slots: { default: 'name' } },
                { minWidth: 190, title: '备注', field: 'remark', tips: '双击编辑备注', slots: { default: 'remark' } , editRender: { name: 'input' }},
                { minWidth: 80, title: '授权账号', field: 'account_id', formatter: item => {
                    return this.$helper.getItemName(this.mediaAccounts, item.row.account_id) || '-'
                }},
                { minWidth: 100, title: '优化师', field: 'worker_id', formatter: item => {
                    return this.$helper.getItemName(this.workers, item.row.worker_id) || '-'
                }, ellipsis: true },
                { minWidth: 200, title: '推广链接', field: 'pts', slots: { default: 'pts' }},
                { minWidth: 120, title: '同步状态',field: 'sync_cost', slots: { default: 'sync_cost' } },
                { minWidth: 80, title: '授权状态',field: 'status',  slots: { default: 'status' } ,fixed: 'right'},
                { minWidth: 80, title: '启用状态',field: 'enabled',  slots: { default: 'enabled' } ,fixed: 'right'},
                { minWidth: 80, title: '是否检测',field: 'check_close_project',  slots: { default: 'check_close_project' } ,fixed: 'right'},
                { minWidth: 80, title: '自动铺户',  slots: { default: 'puhu' } ,fixed: 'right'},
                { minWidth: 245, title: '操作', slots: { default: 'action' },fixed: 'right', },
            ],
            model: {},
            queryParam: {},
            showForm: false,
            pullOauthType: 'advertiser',
            showCostForm: false,
            showBindWorkForm: false,
            showunBindWorkForm: false,
            showSyncCostForm: false,
            showAppForm: false,
            showCreatePtForm: false,
            showCreatePtZyForm: false,
            showWechatAppForm: false,
            showAvatarForm: false,
            showAnchorForm: false,
            showProjectForm: false,
            showCreateEmailForm: false,
            showCreateBudgetForm: false,
            showRemarkForm: false,
            showLabelForm: false,
            showCheckCloseProjectForm: false,
            showUploadForm: false,
            showCampaignForm: false,
            tableHeight: 0,
            tableWidth: 1200,
            out_ids: null,
            tableGrid: this.getTableGrid(),
            showCreateForm: false,
            showCreateProductForm: false,
            anchorModel: {},
            productModel: {},
            eventAssetModel: {},
            showProjectPage: false,
            mediaAccounts:  [],
            showHandselForm: false,
            showEventAssetForm: false,
            showAndroidEventAssetForm: false,
            androidEventAssetModel: {},
            corporations: [],
            editConfig: {
                trigger: 'dblclick', // 触发编辑的方式 'click' | 'dblclick' | 'manual'
                mode: 'cell', // 编辑模式 'cell' | 'row'
            },
            editValueCache: {},
            iconMaterials: [],
            showPromotionReportPage: false,
            confirmVisible: false,
            showCreatePage: false,
            // appTypes: [
            //     {id:1, name:'微小'},
            //     {id:2, name:'抖小'},
            //     {id:3, name:'抖音号'},
            // ],
            appTypes: [],
            showJumpJuliangPage: false,
            jumpJuliangModel: {},
            emails:[],
            emailModel: {},
            remarkModel: {},
            labelModel: {},
            budgetModel: {},
            checkCloseProjectModel: {},
            uploadModel: {},
            showAddAppEventForm: false,
            addAppEventModel: {},
            addAppEventLoading: false,
            appEventOptions: [
                { label: '激活', value: 8 },
                { label: '7日留存', value: 227 },
                { label: '留存天数', value: 393 },
            ],
            addAppEventOptions: [],
            campaignModel: {},
            campaignQueryParam: {
                campaign_id: undefined,
                campaign_name: undefined,
                put_status: undefined,
            },
            campaignSelectedRows: [],
            campaignLoading: false,
            campaignPullLoading: false,
            campaignDeleteLoading: false,
            campaignPutStatusMap: {1: '投放中', 2: '已暂停', 3: '已删除', 4: '执行中'},
            campaignPutStatusColor: {1: 'green', 2: 'orange', 3: 'red', 4: 'blue'},
            campaignPayTypeMap: {1: '付费', 2: '免费'},
            campaignTableGrid: {
                border: 'inner',
                size: 'small',
                data: [],
                loading: false,
                columns: [
                    { type: 'checkbox', width: 50, fixed: 'left' },
                    { minWidth: 170, title: '广告计划ID', field: 'campaign_id', fixed: 'left' },
                    { minWidth: 260, title: '广告计划名称', field: 'campaign_name', ellipsis: true },
                    { minWidth: 100, title: '状态', field: 'put_status', slots: { default: 'campaign_put_status' } },
                    { minWidth: 100, title: '账户类型', field: 'account_pay_type', formatter: item => {
                        return this.campaignPayTypeMap[item.row.account_pay_type] || '-'
                    }},
                    { minWidth: 120, title: '花费(元)', field: 'charge', ellipsis: true },
                    { minWidth: 120, title: '当日ROI(%)', field: 'today_roi', slots: { default: 'campaign_today_roi' } },
                    { minWidth: 170, title: 'ROI口径', field: 'roi_field', formatter: item => {
                        return item.row.roi_field === 'minigame_iaa_purchase_amount' ? 'IAA广告变现ROI' : '付费ROI'
                    }},
                    { minWidth: 100, title: '操作', slots: { default: 'campaign_actions' }, fixed: 'right' },
                ],
                pagerConfig: {
                    currentPage: 1,
                    pageSize: 20,
                    total: 0,
                    pageSizes: [20, 50, 100],
                    layouts: ['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total'],
                },
            },
            workerBindBeforeDays: [{id:1, name:"1天前"},{id:2, name:"2天前"},{id:3, name:"3天前"},{id:4, name:"4天前"},{id:5, name:"5天前"},{id:6, name:"6天前"},{id:7, name:"7天前"}],
            noCosts: [{id:1, name:"近1天"},{id:2, name:"近2天"},{id:3, name:"近3天"}],
            authStatus: [{id:1, name:"正常"},{id:2, name:"授权过期"},{id:3, name:"未授权"}],
            avataStatus: [{id:'UNSET', name:"未设置"},{id:'IN_AUDIT', name:"审核中"},{id:'AUDIT_REJECT', name:"未授审核被拒权"},{id:'AUDIT_PASS', name:"审核通过"}],
            teamSettings: [],
            version_type: 2,
            advertisrTypes: [{id:'侠-', name:'侠客行'}, {id:'巨-', name:'巨广'}],
        }
    },
    created() {
        if (this.type === 'juliang') {
            this.tableWidth = 1700
            this.columns.splice(6, 0,  { minWidth: 120, title: '组织', field: 'organize_name', ellipsis: true, formatter: 'empty' });
            this.columns.splice(7, 0,  { minWidth: 180, title: '主体', field: 'company', ellipsis: true, formatter: 'empty' });
            this.columns.splice(8, 0,  { minWidth: 250, title: '小程序资产',field: 'apps', slots: { default: 'apps' } });
            this.columns.splice(9, 0,  { minWidth: 210, title: '锚点',field: 'anchors', slots: { default: 'anchors' } });
            this.columns.splice(10, 0,   { minWidth: 100, title: '头像',field: 'avatar',  slots: { default: 'avatar' } });
            this.columns.splice(11, 0,   { minWidth: 220, title: '事件资产',field: 'events',  slots: { default: 'events' } });
            this.columns.splice(12, 0,   { minWidth: 80, title: '账户余额',field: 'balance' });
            this.columns.splice(13, 0,   { minWidth: 110, title: '共享钱包余额',field: 'share_balance' });
            this.columns.splice(14, 0,   { minWidth: 200, title: '钱包',field: 'wallet', slots: { default: 'wallet' } });
            this.columns.splice(15, 0,   { minWidth: 200, title: '钱包ID', slots: { default: 'walletId' } });
            this.columns.splice(16, 0,   { minWidth: 110, title: '预算',field: 'budget' , slots: { default: 'budget' } });
        }

        if (['kuaishou', 'juliang'].includes(this.type)) {
            this.columns.splice(8, 0,  { minWidth: 290, title: '落地页',field: 'pages', slots: { default: 'pages' } });
            // this.columns.splice(4, 0,  { minWidth: 190, title: '备注', field: 'remark', slots: { default: 'remark' } });
        }
    },
    watch: {
        out_ids(newVal) {
            this.queryParam.out_id = newVal.replace(/\n/g, ',');
        },
    },
    computed: {
        type () {
            const segments = this.$route.path.split('/')
            return segments[segments.length - 1]
        },
        privilegeType() {
            return this.$helper.ucFirst(this.type)
        },
        actions() {
            return [
                'costs',
                'update' + this.privilegeType,
                'destroy' + this.privilegeType,
            ]
        }
    },
    beforeDestroy() {
        // 组件销毁时，移除全局的键盘事件监听器
        window.removeEventListener('keydown', this.handleKeyDown);
    },
    mounted() {
        // 组件挂载时，添加全局的键盘事件监听器
        window.addEventListener('keydown', this.handleKeyDown);

        this.tableGrid.columns = this.columns
        getCorporations().then(res=>{ this.corporations = res.data.list || {} })
        getMedias().then(res => { this.medias = res.data.list || [] })
        getWorkers().then(res => { 
            let workers = res.data.list || [] 
            workers.unshift({id: 0, name: '无'})
            this.workers = workers
        })
        getTeams().then(res => { this.teams = res.data.list || [] })
        const media = this.$helper.getMediaId(this.type)
        getMediaAccounts({media: media}).then(res => { this.mediaAccounts = res.data.list || [] })
        this.getData()

        getMaterials({page_size: 50, pid: 22}).then(res => {
            this.iconMaterials = res.data.list
        }).catch(() => {
            this.loading = false
        })
        getPlatformAppTypes().then(res => {this.appTypes = res.data.list || []})
        getTeamSettings().then(res => { this.teamSettings = res.data || [] })
    },
    methods: {
        handleKeyDown(event) {
            if (event.key === 'Enter') {
                this.search()
            }
        },
        getTableGrid() {
            let grid = this.$helper.tableGrid('advertisers')
            grid.size = 'medium'
            grid.border = 'inner'
           
            return grid
        },
        handlePageChange(pager) {
            this.tableGrid.pagerConfig.currentPage = pager.currentPage
            this.tableGrid.pagerConfig.pageSize = pager.pageSize
            this.getData()
        },
        handleSortChange(data) {
            this.queryParam.sort_field = data.order ? data.field : null
            this.queryParam.sort_type = data.order
            this.getData()
        },
        showPullForm() {
            this.pullOauthType = 'advertiser'
            this.showForm = true
        },
        // 【已停用】代理商拉取入口
        // showAgentPullForm() {
        //     this.pullOauthType = 'agent'
        //     this.showForm = true
        // },
        showWechatAppPage(record) {
            this.model = Object.assign({}, record)
            this.showWechatAppForm = true
        },
        createApp(type=1) {
            //type=2 说明推广链接创建成功了
            let record
            if (!record) {
                record = {}

                let advertiser
                //获取第一个广告主的信息
                if (type == 2) {
                    //需要重新获取数据
                    getAdvertisers({id: this.model.ids[0]}, this.type).then(res => {
                        advertiser = res.data.list[0]
                        record = this.getRecord(advertiser)
                        if (!record.type) {
                            record.type = 14
                            record.miniapp_name = null
                            record.miniapp_username = null
                            record.link_remark = null
                            record.tag_info = null
                            record.playlet_gender = null
                        }

                        this.model = Object.assign({}, record)
                        this.model.ids = this.selectedRowKeys
                        this.showAppForm = true
                    }).catch(() => {
                        this.loading = false
                    })

                 
                    // advertiser = this.data.find(item => item.id === this.model.ids[0])
                } else {
                    advertiser = this.data.find(item => item.id === this.selectedRowKeys[0])
                    record = this.getRecord(advertiser)
                    // console.log('record', record)

                    if (!record.type) {
                        record.type = 14
                        record.miniapp_name = null
                        record.miniapp_username = null
                        record.link_remark = null
                        record.tag_info = null
                        record.playlet_gender = null
                    }
                    this.model = Object.assign({}, record)
                    this.model.ids = this.selectedRowKeys
               
                    this.showAppForm = true
                }
            }
        },
        getRecord (advertiser) {
            let record = {}
            if (advertiser && advertiser.pts ) {
                const pt = advertiser.pts[0]
                if (pt) {
                    if (pt.platform_id == 25) {
                        record.type = 2
                        record.miniapp_name = '每日剧场'
                        record.miniapp_username = 'tt9c36ea8b0305b6c401'
                        record.link_remark = '{剧名}'
                    } else if (pt.platform_id == 38) {
                        record.type = 7
                        record.miniapp_name = '沁黛剧场'
                        record.miniapp_username = 'tt4a2f3c92d51b1b2e01'
                        record.link_remark = '{剧名}'
                    } else if (pt.platform_id == 178) {
                        record.type = 14
                        record.miniapp_name = '杞岱剧场'
                        record.miniapp_username = 'tt0b847d3994b05ad101'
                        record.link_remark = '{剧名}'
                    } 
                    // else if (pt.platform_id == 9 && pt.channel_id == '1781795995376649') {
                    //     //艳阳热剧-点兰剧场
                    //     record.type = 1
                    //     record.miniapp_name = '点兰剧场'
                    //     record.miniapp_username = 'gh_33d0278b21f6'
                    //     record.link_remark = '{剧名}'
                    // } 
                    else if (pt.platform_id == 72 && pt.channel_id == '1848389704886532') {
                        //主管账号-怅栗好看
                        record.type = 11
                        record.miniapp_name = '怅栗好看'
                        record.miniapp_username = 'gh_10e4959aab23'
                        record.link_remark = '{剧名}'
                    } 
                    else if (pt.platform_id == 179 && pt.channel_id == '1872571643960388') {
                        //主管账号-堂卷好看
                        record.type = 15
                        record.miniapp_name = '堂卷好看'
                        record.miniapp_username = 'gh_4aeba2680d40'
                        record.link_remark = '{剧名}'
                    } 
                    else if (pt.platform_id == 9 && pt.channel_id == '1772481781470557') {
                        //菠萝热剧-月桦剧场
                        record.type = 1
                        record.miniapp_name = '月桦剧场'
                        record.miniapp_username = 'gh_39865d75603a'
                        record.link_remark = '{剧名}'
                    } else if (pt.platform_id == 33 && pt.channel_id == '1800202630235211') {
                        //常读制剧-主管-常读制剧
                        record.type = 3
                        record.miniapp_name = '常读制剧'
                        record.miniapp_username = 'ttf3bc85016c8a4e7001'
                        record.link_remark = '{剧名}'
                    } else if (pt.platform_id == 22 && pt.channel_id == '21848') {
                        //宝藏剧场 - 宝藏剧场-抖音小程序-八人行
                        record.type = 5
                        record.miniapp_name = '宝藏剧场'
                        record.miniapp_username = 'tt915ce7e10e62aad901'
                        record.link_remark = '{剧名}'
                    } else if (pt.platform_id == 35 && pt.channel_id == '49483') {
                        //青稞短剧 - 青稞短剧1-头条直投-八人行
                        record.type = 4
                        record.miniapp_name = '青稞短剧'
                        record.miniapp_username = 'gh_e979f24d478c'
                        record.link_remark = '{剧名}'
                    } else if (pt.platform_id == 36) {
                        //海狮剧场-点众
                        record.type = 6
                        record.miniapp_name = '海狮剧场'
                        record.miniapp_username = 'ttaa72dccf3544da4701'
                        record.link_remark = '{剧名}'
                    } else if (pt.platform_id == 174) {
                        //雪蘅剧场-点众(IAA)
                        record.type = 12
                        record.miniapp_name = '雪蘅剧场'
                        record.miniapp_username = 'ttaf0ed9b330067c4501'
                        record.link_remark = '{剧名}'
                    } else if (pt.platform_id == 175) {
                        //秘境短剧-点众(IAP)
                        record.type = 13
                        record.miniapp_name = '秘境短剧'
                        record.miniapp_username = 'tt726104dced6a3eb501'
                        record.link_remark = '{剧名}'
                    } else if (pt.platform_id == 39) {
                        //源寒短剧-掌阅 微小
                        record.type = 8
                        record.miniapp_name = '源寒短剧'
                        record.miniapp_username = 'gh_8fb81d8e2bcd '
                        record.link_remark = '{剧名}'
                    } else if (pt.platform_id == 40) {
                        //苍翠微剧-掌阅 抖小
                        record.type = 9
                        record.miniapp_name = '苍翠微剧'
                        record.miniapp_username = 'tt2f7c59c1b04cbb7801 '
                        record.link_remark = '{剧名}'
                    } 
                }
              
            } 
            record.tag_info = null
            record.playlet_gender = null
            return record
        },
        createAnchor() {
            const ids = this.selectedRowKeys
            const advertisers = []
            // console.log('ids',ids)

            let error = ""
           

            this.data.forEach(item => {
                //过滤没有资产的广告主
                if (ids.includes(item.id)) {
                    if (item.juliang_apps && item.juliang_apps.length>0) {
                        advertisers.push({advertiser_id: item.id, out_id: item.out_id, advertiser_name: item.name, apps: item.juliang_apps ? item.juliang_apps : [], pts: item.pts ? item.pts : []})
                    } else {
                        error += item.out_id+","
                    }
                }
            });

            if (advertisers.length<1) {
                return this.$message.error('请先创建小程序资产！')
            }
            if (error) {
                error = '所选广告主：' + error
                this.$message.error(error + '没有小程序资产，已移除')
            }
            // console.log('advertisers',advertisers)

         

            this.anchorModel = {
                anchor_type: 'APP_INTERNET_SERVICE', //样式:网服
                net_service_type: 'MICRO_APP', //推广内容：微信小程序
                ios_anchor_title: '观看精彩后续',
                android_anchor_title: '观看精彩后续',
                app_description: '无需下载点击即看精彩短剧集锦，全程无广随心看~', //APP详情
                advertisers: advertisers,
                app_tags: ['高能反转', '看大结局', '火爆短剧'],
                guide_text: '剧情精彩超过瘾',
                iconMaterials: this.iconMaterials
            }
            this.showCreateForm = true
        },
        storeAvatar(bind_worker = false) {
            this.model = Object.assign({
                source_info : null,
                avatar: null,
                bind_worker: bind_worker,
                worker_id: null,
            })
            this.model.ids = this.selectedRowKeys
            this.showAvatarForm = true
        },
        showAnchorPage(record) {
            this.model = Object.assign({}, record)
            this.showAnchorForm = true
        },
        syncCost() {
            this.model = { ids: this.selectedRowKeys }
            this.showSyncCostForm = true
        },
        showPage(record){
            this.model = Object.assign({}, record)
            this.showCostForm = true
        },
        createProject(record) {
            this.model = Object.assign({}, record)
            this.model.ids = this.selectedRowKeys
            this.showProjectForm = true
        },
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys
        },
        getData() {
            this.tableGrid.loading = true
            const json = Object.assign({}, this.queryParam, {
                page: this.tableGrid.pagerConfig.currentPage,
                page_size: this.tableGrid.pagerConfig.pageSize
            })
            getAdvertisers(json, this.type).then(res => {
                this.tableGrid.pagerConfig.total = res.data.total
                this.tableGrid.loading = false
                this.tableGrid.data = res.data.list
                this.data = res.data.list || []
            }).catch(() => {
                this.tableGrid.loading = false
            })
        },
        refresh() {
            this.getData()
        },
        search() {
            this.tableGrid.pagerConfig.currentPage = 1
            this.getData()
        },
        resetSearch() {
            this.queryParam = {}
            this.getData()
        },
        accessTo(route) {
            let controller = 'AdvertiserController'
            if (route.indexOf('@') !== -1) {
                const routeArr = route.split('@')
                controller = routeArr[0]
                route = routeArr[1]
            }
            return this.$helper.accessTo(controller, route)
        },
        accessToJuliangProject(route) {
            return this.type === 'juliang' && this.$helper.accessTo('ProjectController', route)
        },
        updateAdvertiser(id, enabled, field, refresh) {
            const update = ids => {
                const data = {
                    id: ids,
                    field: field,
                    value: enabled
                }
                updateAdvertiser(data, this.type).then(() => {
                    if (refresh) {
                        this.$message.destroy()
                        this.$message.success('操作成功')
                        this.refresh()
                    }
                }).catch(() => {
                    this.tableGrid.loading = false
                })
            }
            if (!id) {
                const actionType = enabled ? '启用' : '禁用'
                return this.$confirm({
                    title: '操作提示',
                    centered: true,
                    content: () => <div style="color:red;">确定要{actionType} {this.selectedRowKeys.length} 条广告主吗?</div>,
                    onOk: () => {
                        update(this.selectedRowKeys)
                    }
                })
            }
            update([id])
        },
        destroy(record) {
            const del = ids => {
                deleteAdvertisers(ids, this.type).then(res => {
                    this.$message.destroy()
                    if (res && res.code === 0) {
                        this.$message.success('删除成功')
                        this.refresh()
                    }
                })
            }
            if (!record) {
                return this.$confirm({
                    title: '操作提示',
                    centered: true,
                    content: () => <div style="color:red;">确定要删除选中的 {this.selectedRowKeys.length} 条数据吗?</div>,
                    onOk: () => {
                        del(this.selectedRowKeys)
                    }
                })
            }
            del([record.id])
        },
        copyToken(token) {
            this.$helper.clipboard(token)
            this.$message.success('复制成功')
        },
        bindWork(record) {
            this.model = Object.assign({}, record)
            this.model.ids = this.selectedRowKeys
            this.model.media_type = this.type
            this.showBindWorkForm = true
        },
        unbindWork(record) {
            this.model = Object.assign({}, record)
            this.model.ids = this.selectedRowKeys
            this.model.media_type = this.type
            this.showunBindWorkForm = true
        },
        handleRowChange(result) {
            this.selectedRowKeys = result.records.flatMap((item) => {
                return item.id
            })
        },
        pullAvatar(item) {
            let ids = []
            if (!item) {
                ids = this.selectedRowKeys
            } else {
                ids = [item.id]
            }

            this.tableGrid.loading = true
            pullAvatar({ids: ids}).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success('同步头像成功')
                    this.refresh()
                } else {
                    this.$message.error('同步头像失败')
                }
            }).catch(() => {
                this.tableGrid.loading = false
            })
        },
        createPt(platform_type) {
            this.model = {
                platform_id: null,
                platform_type: platform_type,
                name: null,
                recharge_template_id: '',
                follow_recharge_template_id: '',
                video_id: '',
                chapter_num: 1,
                start_chapter: null,
                price: null,
                media_source: null,
                ad_callback_config_id: null,
                distributor_id: '',
                pack_strategy_status: 0, //起量助手
                guide_chapter: 0,
                rows: [],
            }
            this.model.ids = this.selectedRowKeys

            let selectAdvertisers = []
            this.data.forEach(item => {
                //选中的广告主
                if (this.selectedRowKeys.includes(item.id)) {
                    selectAdvertisers.push({advertiser_id: item.id, out_id: item.out_id, advertiser_name: item.name, remark: item.remark})
                }
            });
            this.model.selectAdvertisers = selectAdvertisers
            if (platform_type === 15) {
                // 掌阅
                this.showCreatePtZyForm = true
            } else {
                this.showCreatePtForm = true
            }
        },
        pullWechatApp(type) {
            const json = {
                ids: this.selectedRowKeys,
                type: type
            }
            this.tableGrid.loading = true
         
            pullWechatApp(json).then(res => {
                this.$message.destroy()
                if (res && res.code == 0) {
                    this.$message.success('同步小程序资产成功')
                    this.refresh()
                } else {
                    this.$message.error('同步小程序资产失败')
                }
            }).catch(() => {
                this.tableGrid.loading = false
            })
        },
        pullAnchor() {
            const json = {
                ids: this.selectedRowKeys,
            }
            this.tableGrid.loading = true
            pullAnchor(json).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success('同步锚点成功')
                    this.getData()
                } else {
                    this.$message.error('同步锚点失败')
                }
            }).catch(() => {
                this.tableGrid.loading = false
            })
        },
        showProject(record) {
            this.model = Object.assign({}, record)
            this.showProjectPage = true
        },
        /**
         * 打开快手广告计划弹窗，进入时先查本地计划，避免误触远程拉取。
         */
        showCampaignPage(record) {
            this.campaignModel = Object.assign({}, record)
            this.showCampaignForm = true
            this.campaignSelectedRows = []
            this.campaignQueryParam = {
                campaign_id: undefined,
                campaign_name: undefined,
                put_status: undefined,
            }
            this.campaignTableGrid.pagerConfig.currentPage = 1
            this.fetchAdvertiserCampaigns()
        },
        /**
         * 查询广告主计划列表，后端按media_accounts.pay_type返回当日ROI。
         */
        fetchAdvertiserCampaigns() {
            if (!this.campaignModel || !this.campaignModel.out_id) {
                return
            }

            this.campaignTableGrid.loading = true
            const params = {
                ...this.campaignQueryParam,
                advertiser_id: this.campaignModel.out_id,
                page: this.campaignTableGrid.pagerConfig.currentPage,
                page_size: this.campaignTableGrid.pagerConfig.pageSize,
            }
            getAdvertiserCampaigns(params).then(res => {
                this.campaignTableGrid.data = (res.data && res.data.list) || []
                this.campaignTableGrid.pagerConfig.total = (res.data && res.data.total) || 0
                this.campaignSelectedRows = []
            }).catch(() => {
                this.campaignTableGrid.data = []
            }).finally(() => {
                this.campaignTableGrid.loading = false
            })
        },
        handleCampaignPageChange(pager) {
            this.campaignTableGrid.pagerConfig.currentPage = pager.currentPage
            this.campaignTableGrid.pagerConfig.pageSize = pager.pageSize
            this.fetchAdvertiserCampaigns()
        },
        handleCampaignRowChange(result) {
            this.campaignSelectedRows = result.records || []
        },
        isCampaignRoiDanger(row) {
            const roi = Number(row.today_roi || 0)
            return row.account_pay_type === 2 ? roi > 90 : roi > 95
        },
        searchCampaigns() {
            this.campaignTableGrid.pagerConfig.currentPage = 1
            this.fetchAdvertiserCampaigns()
        },
        resetCampaignSearch() {
            this.campaignQueryParam = {
                campaign_id: undefined,
                campaign_name: undefined,
                put_status: undefined,
            }
            this.searchCampaigns()
        },
        /**
         * 拉取当前广告主所有快手计划，完成后刷新本地列表。
         */
        pullCampaigns() {
            this.campaignPullLoading = true
            pullAdvertiserCampaigns({advertiser_id: this.campaignModel.out_id}).then(res => {
                if (res && res.code === 0) {
                    this.$message.success(`拉取完成，更新 ${res.data.total || 0} 个广告计划`)
                    this.fetchAdvertiserCampaigns()
                } else {
                    this.$message.error(res.message || '拉取失败')
                }
            }).finally(() => {
                this.campaignPullLoading = false
            })
        },
        /**
         * 删除选中的快手广告计划，远程成功后后端会同步本地删除状态。
         */
        deleteSelectedCampaigns() {
            const rows = this.campaignSelectedRows.filter(row => row.put_status !== 3)
            if (rows.length < 1) {
                return this.$message.warning('请选择未删除的广告计划')
            }

            this.$confirm({
                title: '操作提示',
                centered: true,
                content: () => <div style="color:red;">确认删除选中的 {rows.length} 个广告计划吗？</div>,
                onOk: () => this.doDeleteCampaigns(rows.map(row => row.campaign_id)),
            })
        },
        deleteCampaign(row) {
            this.$confirm({
                title: '操作提示',
                centered: true,
                content: () => <div style="color:red;">确认删除广告计划 {row.campaign_id} 吗？</div>,
                onOk: () => this.doDeleteCampaigns([row.campaign_id]),
            })
        },
        doDeleteCampaigns(campaignIds) {
            this.campaignDeleteLoading = true
            return deleteAdvertiserCampaigns({
                advertiser_id: this.campaignModel.out_id,
                campaign_ids: campaignIds,
            }).then(res => {
                if (res && res.code === 0) {
                    const successCount = (res.data.success || []).length
                    const errors = res.data.errors || []
                    if (successCount > 0) {
                        this.$message.success(`删除成功 ${successCount} 个广告计划`)
                    }
                    if (errors.length > 0) {
                        this.$message.error(errors.join('；'))
                    }
                    this.fetchAdvertiserCampaigns()
                } else {
                    this.$message.error(res.message || '删除失败')
                }
            }).finally(() => {
                this.campaignDeleteLoading = false
            })
        },
        /**
         * 删除该广告主全部未删除计划，适合清理整户计划。
         */
        deleteAllCampaigns() {
            this.$confirm({
                title: '危险操作确认',
                centered: true,
                content: () => <div style="color:red;">确认删除广告主 {this.campaignModel.out_id} 下全部未删除广告计划吗？</div>,
                onOk: () => {
                    this.campaignDeleteLoading = true
                    return deleteAllAdvertiserCampaigns({advertiser_id: this.campaignModel.out_id}).then(res => {
                        if (res && res.code === 0) {
                            const successCount = (res.data.success || []).length
                            const errors = res.data.errors || []
                            this.$message.success(`删除成功 ${successCount} 个广告计划`)
                            if (errors.length > 0) {
                                this.$message.error(errors.join('；'))
                            }
                            this.fetchAdvertiserCampaigns()
                        } else {
                            this.$message.error(res.message || '删除失败')
                        }
                    }).finally(() => {
                        this.campaignDeleteLoading = false
                    })
                },
            })
        },
        syncLandingPage(item) {
            let ids = []
            if (!item) {
                ids = this.selectedRowKeys
            } else {
                ids = [item.id]
            }

            this.tableGrid.loading = true
            syncLandingPage({ids: ids}).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success('同步落地页成功')
                    this.refresh()
                } else {
                    this.$message.error('同步落地页失败')
                }
            }).catch(() => {
                this.tableGrid.loading = false
            })
        },
        syncRemark(item) {
            let ids = []
            if (!item) {
                ids = this.selectedRowKeys
            } else {
                ids = [item.id]
            }

            this.tableGrid.loading = true
            syncLandingPage({ids: ids, type: 'syncRemark'}).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success('同步备注成功')
                    this.refresh()
                } else {
                    this.$message.error('同步备注失败')
                }
            }).catch(() => {
                this.tableGrid.loading = false
            })
        },
        canHandsel (record) {
            //检查被转赠的广告主是否有通过的落地页 (通过，审核中，已上线)
            let set_id = null
            record.landing_pages.forEach(item => {
                if (item.status === 'auditAccepted' || item.status === 'AUDIT_ACCEPTED' || item.status === 'AUDIT_DOING' || item.status === 'ENABLE') {
                    if (!set_id) {
                        set_id = item.out_id
                    }
                }
            });
            return set_id
        },
        clickHandsel(record) {
            //被转赠的广告主
            const ids = this.selectedRowKeys
            if ( ids.length < 1 ) {
                return this.$message.error('请先选择被转赠的广告主！')
            }
            if (ids.includes(record.id)) {
                return this.$message.error('被转赠广告主不能包含转赠广告主！')
            }
            //检查被转赠的广告主是否有通过的落地页
            let set_id = this.canHandsel(record)
            if (set_id < 1) {
                return this.$message.error('被转赠的广告主没有通过审核的落地页！')
            }

            const advertisers = []
            let error = ""
            this.data.forEach(item => {
                //过滤没有资产的广告主
                if (ids.includes(item.id)) {
                    if (item.juliang_apps && item.juliang_apps.length>0) {
                        advertisers.push({advertiser_id: item.id, out_id: item.out_id, advertiser_name: item.name, apps: item.juliang_apps ? item.juliang_apps : []})
                    } else {
                        error += item.out_id+","
                    }
                }
            });

            if (advertisers.length < 1) {
                return this.$message.error('被转赠广告主请先创建小程序资产！')
            }
            if (error) {
                error = '所选广告主：' + error
                this.$message.error(error + '没有小程序资产，已移除')
            }

            //选择一个正常状态的落地页
            this.model = {
                landingPages: record.landing_pages,
                advertisers: advertisers,
                site_id: set_id,
                advertiser_id: record.id, 
            }
            this.showHandselForm = true
        },
        changeOutId () {
            const inputValue = this.queryParam.out_id;
            this.out_ids = inputValue.replace(/,/g, '\n');
        },
        pullEventAsset() {
            const json = {
                ids: this.selectedRowKeys,
            }
            this.tableGrid.loading = true
         
            pullEventAsset(json).then(res => {
                this.$message.destroy()
                if (res && res.code == 0) {
                    this.$message.success('同步事件资产成功')
                    this.refresh()
                } else {
                    this.$message.error('同步事件资产失败')
                }
            }).catch(() => {
                this.tableGrid.loading = false
            })
        },
        createEventAsset() {
            const ids = this.selectedRowKeys
            const advertisers = []
            // console.log('ids',ids)

            let error = ""
            this.data.forEach(item => {
                //过滤没有字节小程序资产的广告主
                if (ids.includes(item.id)) {
                    let juliang_zijie_apps = []
                    if (item.juliang_apps && item.juliang_apps.length>0) {
                        juliang_zijie_apps = item.juliang_apps.filter(app => app.type === 2 && app.audit_status === "AUDIT_ACCEPTED");
                    }

                    if (juliang_zijie_apps.length>0) {
                        advertisers.push({advertiser_id: item.id, out_id: item.out_id, advertiser_name: item.name, apps: juliang_zijie_apps})
                    } else {
                        error += item.out_id+","
                    }
                }
            });

            if (advertisers.length<1) {
                return this.$message.error('所有广告主没有通过通过审核的字节小程序，请等待或者同步数据')
            }
            if (error) {
                error = '所选广告主：' + error
                this.$message.error(error + '没有通过审核字节小程序，已移除')
            }

            this.eventAssetModel = {
                asset_type: 'MINI_PROGRAME', 
                event_id: 1000000, 
                ids: this.selectedRowKeys, 
                advertisers: advertisers, 
            }
     
            this.showEventAssetForm = true
        },
        createAndroidEventAsset() {
            const ids = this.selectedRowKeys
            if (ids.length === 0) {
                return this.$message.error('请选择广告主')
            }

            this.androidEventAssetModel = {
                ids: this.selectedRowKeys,
                app_id: 455850,
                app_name: '红果免费短剧',
                package_name: 'com.phoenix.read',
                download_url: 'https://apps.bytesfield.com/download/basic/cur/24ceb0235a1ee2b2052af5cde8c228a34061fbe8',
                package_id: '24ceb0235a1ee2b2052af5cde8c228a34061fbe8',
                event_ids: [8, 227, 393],
                track_url_group_name: '',
                action_track_url: '',
                track_url: '',
                video_play_track_url: '',
                video_play_done_track_url: '',
                video_play_effective_track_url: '',
                active_track_url: '',
            }

            this.showAndroidEventAssetForm = true
        },
        /**
         * 打开APP资产补事件弹窗，并把本地已创建事件置灰避免重复提交。
         */
        addAppEventAssetEvents(asset) {
            const options = this.getAddAppEventOptions(asset)
            const createdEventNames = options.filter(item => item.disabled).map(item => this.getAppEventName(item.value))
            if (!options.some(item => !item.disabled)) {
                return this.$message.warning(`${createdEventNames.join('、')}已创建，无需重复创建`)
            }

            this.addAppEventOptions = options
            this.addAppEventModel = {
                asset_id: asset.asset_id,
                app_id: 455850,
                app_name: '红果免费短剧',
                package_name: 'com.phoenix.read',
                download_url: 'https://apps.bytesfield.com/download/basic/cur/24ceb0235a1ee2b2052af5cde8c228a34061fbe8',
                package_id: '24ceb0235a1ee2b2052af5cde8c228a34061fbe8',
                event_ids: [],
            }
            this.showAddAppEventForm = true
        },
        /**
         * 从广告主事件资产列表中获取唯一维护的APP资产记录。
         */
        getFirstAppEventAsset(row) {
            return (row.juliang_event_assets || []).find(item => item.asset_type === 'APP')
        },
        /**
         * 解析APP资产已创建事件ID，兼容接口返回数组或对象结构。
         */
        getCreatedAppEventIds(asset) {
            const configs = Array.isArray(asset.event_configs) ? asset.event_configs : Object.values(asset.event_configs || {})
            // 本地事件配置可能来自对象或数组结构，统一转成数字ID用于禁用重复事件。
            return configs.map(item => Number(item.event_id)).filter(item => item)
        },
        /**
         * 根据事件ID获取页面展示名称，未知事件保留原ID便于排查。
         */
        getAppEventName(eventId) {
            const event = this.appEventOptions.find(item => item.value === Number(eventId))
            return event ? event.label : eventId
        },
        /**
         * 生成补事件弹窗选项，已创建事件显示标记并禁用。
         */
        getAddAppEventOptions(asset) {
            const createdEventIds = this.getCreatedAppEventIds(asset)
            return this.appEventOptions.map(item => {
                const disabled = createdEventIds.includes(Number(item.value))
                return {
                    ...item,
                    label: disabled ? `${item.label}（已创建）` : item.label,
                    disabled,
                }
            })
        },
        /**
         * 提交APP补事件任务，前端先兜底过滤已创建事件，后端仍会做强校验。
         */
        submitAddAppEventAssetEvents() {
            if (!this.addAppEventModel.event_ids || this.addAppEventModel.event_ids.length < 1) {
                return this.$message.error('请选择要添加的事件')
            }
            const disabledIds = this.addAppEventOptions.filter(item => item.disabled).map(item => Number(item.value))
            const duplicatedIds = this.addAppEventModel.event_ids.filter(item => disabledIds.includes(Number(item)))
            if (duplicatedIds.length > 0) {
                const duplicatedEventNames = duplicatedIds.map(item => this.getAppEventName(item))
                return this.$message.error(`${duplicatedEventNames.join('、')}已创建，无需重复创建`)
            }

            this.addAppEventLoading = true
            addAppEventAssetEvents(this.addAppEventModel).then(res => {
                if (res && res.code === 0) {
                    this.$message.success('新增事件任务已提交，请在应用事件任务列表查看执行结果')
                    this.showAddAppEventForm = false
                    this.addAppEventModel = {}
                } else {
                    this.$message.error(res.message)
                }
                this.addAppEventLoading = false
            }).catch(() => {
                this.addAppEventLoading = false
            })
        },
        handleEditActived(params) {
            const { row } = params
            // 在编辑开始时记录原始值
            this.editValueCache = { ...row }
        },
        handleEditClosed(params) {
            const { row } = params

            // console.log('aa1', this.editValueCache.remark)
            // console.log('aa2', row.remark)
            // 对比原始值和当前值
            if (this.editValueCache.remark !== row.remark) {
                // console.log('aaa', params)
             
                let ids = [row.id]
          
                this.tableGrid.loading = true
                syncLandingPage({ids: ids, remark: row.remark, old_remark:this.editValueCache.remark, type: 'editRemark'}).then(res => {
                    // console.log(res)
                    if (res.data.code && res.data.code == 700) {
                        this.$message.destroy()
                        this.tableGrid.loading = false
                        //此处需要确认弹窗
                        this.showConfirm(res.data.message, {ids: ids, remark: row.remark, old_remark:this.editValueCache.remark+'222', type: 'editRemark', 'confirm':true})
                        this.confirmVisible = true; // 返回 700 时，显示确认弹窗
                        // 手动触发隐藏的按钮来弹出确认框
                        // this.$refs.triggerConfirm.$el.click();

                    } else {
                        this.$message.destroy()
                        if (res && res.code === 0) {
                            this.$message.success('编辑备注成功')
                            this.refresh()
                        } else {
                            this.tableGrid.loading = false
                            this.$message.error('编辑备注失败')
                        }
                    }
                    this.tableGrid.loading = false
                }).catch(() => {
                    this.tableGrid.loading = false
                })
            }
        },
        showConfirm(message, params) {
            // 使用箭头函数来保持 `this` 的上下文
            this.$confirm({
                title: message,
                content: '点击确认继续操作',
                onOk: () => { // 使用箭头函数
                    this.tableGrid.loading = true; // 设置加载状态
                    syncLandingPage(params).then(res => {
                        this.$message.destroy(); // 销毁消息
                        if (res && res.code === 0) {
                            this.$message.success('编辑备注成功'); // 显示成功消息
                            this.refresh(); // 刷新数据
                        } else {
                            this.$message.error('编辑备注失败'); // 显示失败消息
                        }
                        this.tableGrid.loading = false; // 结束加载状态
                    }).catch(() => {
                        this.tableGrid.loading = false; // 处理错误，结束加载状态
                    });
                },
                onCancel: () => {
                    // 处理取消逻辑，如果需要
                },
            });
        },
        showPromotionReport (advertiser_media, advertiser_id, show_name) {
            if (advertiser_media!=1 && advertiser_media!=2 ) {
                return this.$message.error('目前只有巨量和快手账户支持查看广告报表')
            }
            let day = moment()

            const json = {
                advertiser_id:advertiser_id ,
                started_at: day, finished_at: day,
                show_name: show_name,
                media_name: advertiser_media === 1 ? '快手' : '头条',
                media: advertiser_media,
            }

            this.model = Object.assign({}, json)
            this.showPromotionReportPage = true
        },
        copyOutIds () {
            if (this.selectedRowKeys.length === 0) {
                this.$message.warning('请选择账户ID');
                return;
            }

            let selectedIds = []
            this.data.forEach(item => {
                if (this.selectedRowKeys.includes(item.id)) {
                    selectedIds.push(item.out_id)
                }
            });

            this.$helper.clipboard(selectedIds.join('\n'));
            this.$message.success('复制成功')
        },
        syncAdvertiserName(item) {
            let ids = []
            if (!item) {
                ids = this.selectedRowKeys
            } else {
                ids = [item.id]
            }

            this.tableGrid.loading = true
            syncAdvertiserName({ids: ids}).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success('同步昵称成功')
                    this.refresh()
                } else {
                    this.$message.error('同步昵称失败')
                }
            }).catch(() => {
                this.tableGrid.loading = false
            })
        },
        createProduct(type=1) {
            let ids
            if (type == 1) {
                ids = this.selectedRowKeys
                if (ids.length<1) {
                    return this.$message.error('请先选择广告主！')
                }
            } else {
                ids = null
            }
          
       
            this.productModel = {
                product_type: null,
                is_copy: 1,
                show_type: type,
                advertiser_ids: ids,
                product_platform_id: null, //商品库ID: iaa-超超低 157950614275891
                name: null, //剧名称
                dpa_category:[], //剧分类
                profession: { //额外信息
                    micro_app_link: null, //字节小程序推广链接
                    copyright_owner: null, //版权方主体名称
                    has_paid_content: "1", //变现模式： 1-付费 2-免费
                    has_motivation_content: 2, //是否包含网赚内容: 1-是 2-否
                    playlet_gender: "1", //短剧男女频: 1-男 2-女 3-其他
                    playlet_num: null, //集数
                    playlet_duration: 1, //单集剧集时长(分钟)
                    starting_unlock_episode: 10, //起始解锁集数
                    start_pay_playlet: 15, //起始付费集数
                    max_charge: null, 
                    min_charge: null, 
                    recommended_charge: null, 
                },
                price_info: {
                    price: null,
                },
                image_url:null,//商品图片
            }
            this.showCreateProductForm = true
        },
        accessToAdvertiser(route) {
            return this.$helper.accessTo('AdvertiserController', route)
        },
        createAdvertiserTask(record)
        {
            this.showCreatePage = true
            this.model = {ad_id: record.id,corporation_id: record.corporation_id, platform_id: record.platform_id, p_type:record.p_type, platform_app_type:record.platform_app_type,pay_type:record.pay_type}
        },
        clickJuliang (out_id)
        {
            // let url = 'https://ad.oceanengine.com/promotion/promote-manage/project?aadvid=' + out_id
            let url = 'https://ad.oceanengine.com/promotion/promote-manage/ad?aadvid=' + out_id
            // console.log('点击了广告主', out_id)

            if (this.accessToAdvertiser('autoLogin')) { 
                getJuliangEmails({out_id:out_id}).then(res => { 
                    this.emails = res.data.list || [] 
                    //没有绑定邮箱，直接跳转
                    if (this.emails.length < 1 ) {
                        window.open(url, '_blank')
                    } else {
                        //开启弹窗，选择巨量邮箱跳转
                        this.jumpJuliangModel = {
                            out_id: out_id,
                            url: url,
                            emails: this.emails
                        }
                        this.showJumpJuliangPage = true
                    }
                })
            } else {
                window.open(url, '_blank')
            }
            
        
        },
        showFormPage (item, field) {
            this.emailModel = {
                id: item.id,
                email: item.email,
                field: field,
                value: item[field],
                type: this.type,
                emails: [],
            }
            this.showCreateEmailForm = true
            // 快手：邮箱来源是【邮箱配置】(media=快手)，先拉取可选邮箱，弹窗内改为下拉选择，
            // 避免手填邮箱与配置不一致导致绑定到无登录态的账号
            if (this.type === 'kuaishou' && field === 'email') {
                getKuaishouEmails({ out_id: item.out_id }).then(res => {
                    this.emailModel.emails = (res && res.data && res.data.list) || []
                }).catch(() => {})
            }
        },

        updateBudget () {
            let record = {}
            record.ids = this.selectedRowKeys
            record.media_type = this.type
            record.budget = null
            this.budgetModel = Object.assign({}, record)
            this.showCreateBudgetForm = true
        },
        updateRemark () {
            let record = {}
            record.ids = this.selectedRowKeys
            record.media_type = this.type
            record.remark = ""
            this.remarkModel = Object.assign({}, record)
            this.showRemarkForm = true
        },
        updateLabel () {
            let record = {}
            record.ids = this.selectedRowKeys
            record.media_type = this.type
            record.label = null
            this.labelModel = Object.assign({}, record)
            this.showLabelForm = true
        },
        updateCheckCloseProject () {
            let record = {}
            record.ids = this.selectedRowKeys
            record.media_type = this.type
            record.check_close_project = true
            this.checkCloseProjectModel = Object.assign({}, record)
            this.showCheckCloseProjectForm = true
        },
        batchUpload() {
            this.uploadModel = {
                type: this.type,
            }
            this.showUploadForm = true
        },
        copy(str) {
            this.$helper.clipboard(str)
            this.$message.success('复制成功')
        },
        exportCsv() {
            const total = this.tableGrid.pagerConfig.total;
            this.$confirm({
                title: '确认导出？',
                content: `当前导出数据条数为：${total}，确认继续导出吗？`,
                okText: '确认',
                cancelText: '取消',
                onOk: () => {
                    this.tableGrid.loading = true
                    const json = Object.assign({}, this.queryParam, {})
                    return getExportCsv(json, this.type).then(res => {
                        this.$message.destroy()
                        if (res && res.code === 0) {
                            this.$message.success('导出成功')

                            // 自动下载文件
                            if (res.data && res.data.url) {
                                const link = document.createElement('a')
                                link.href = res.data.url
                                link.download = ''  // 可留空，让后端 header 指定文件名
                                document.body.appendChild(link)
                                link.click()
                                document.body.removeChild(link)
                            }
                            
                            this.refresh()
                        } else {
                            this.$message.error('导出失败')
                        }
                    }).catch(() => {
                        this.$message.error('导出失败')
                    }).finally(() => {
                        this.tableGrid.loading = false
                    })
                },
                onCancel: () => {
                    this.$message.info('已取消导出')
                }
            })
        },
        createApp2(version_type) {
            console.log('父组件', version_type)
            this.version_type = version_type
        },
        getAvatarStatusName(status) {
            let item = this.avataStatus.find(item => item.id === status)
            return item.name
        }
    }
}
